import React from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.css";
import footer_logo from "../Assets/Frontend_Assets/logo_big.png";
import instagram from "../Assets/Frontend_Assets/instagram_icon.png";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer">
       <div className="overlay"></div>
      <div className="footer-container">

        {/* BRAND */}
        <div className="footer-brand">
          <img src={footer_logo} alt="RunWear Shoes" />
          <h3>RunWear Shoes</h3>
          <p>
            Premium fashion store delivering quality & style across Pakistan.
          </p>
        </div>

        {/* CONTACT US */}
        <div className="footer-column">
          <h4>Contact Us</h4>
          <p>📍 Waheed acrade near alhabib bank main pwd islamabad</p>
          <p>📧 Runwearshoes@gmail.com</p>
          <p>📞 +923029849191</p>
        </div>

        {/* INFORMATION */}
        <div className="footer-column">
          <h4>Information</h4>
          <ul>
            <li onClick={() => navigate("/Blogs")}>Blogs</li>
            <li onClick={() => navigate("/about")}>About Us</li>
            {/* <li onClick={() => navigate("/catalogue")}>Catalogues</li> */}
            <li onClick={() => navigate("/privacy-policy")}>Privacy Policy</li>
            <li onClick={() => navigate("/terms")}>Terms & Conditions</li>
          </ul>
        </div>

        {/* CUSTOMER SERVICE */}
        <div className="footer-column">
          <h4>Customer Services</h4>
          <ul>
            <li onClick={() => navigate("/faq")}>FAQs</li>
            <li onClick={() => navigate("/my-orders")}>Order Tracking</li>
            {/* <li onClick={() => navigate("/store-locator")}>Store Locator</li> */}
            <li onClick={() => navigate("/ContactUs")}>Contact Us</li>
          </ul>
        </div>
      </div>

      {/* SOCIAL */}
      <div className="footer-social">
        <img src={instagram} alt="Instagram" />
        <img src={instagram} alt="Instagram" />
        <img src={instagram} alt="Instagram" />
      </div>

      {/* COPYRIGHT */}
      <div className="footer-bottom">
        <hr />
        <p>© 2026 RunWear Shoes. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
